import { mapState, mapActions } from 'vuex'

// 任意のサービスに登録されたRSSから選択するUIモジュール
// ●使用箇所
// 「サービス管理-コンテンツ設定-画面別設定-画面別コンテンツ編集」
export default {
  name: 'NoticeTypeMstSelectButton',
  props: {
    name: {
      type: String,
      require: true
    },
    index: {
      type: Number,
      require: false,
      default: 0
    },
    model: {
      type: Array,
      require: false,
      'default': () => []
    },
    disabled: {
      type: Boolean,
      require: false,
      'default': () => false
    }
  },
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      buttonId: state => state.selectNoticeTypeMstModal.buttonId,
      value: state => state.selectNoticeTypeMstModal.value,

      // model
      noticeTypeMstModel: state => state.selectNoticeTypeMstModal.noticeTypeMstModel,
    }),

    results () {
      if (this.loading) return ''
      // console.log('value', this.value)
      // RSS名を取得
      try {
        return this.value.map(id => this.noticeTypeMstModel.filter(item => item.noticeTypeMstUuid == id)[0].noticeTypeName).join('、')
        // return this.noticeTypeMstModel
        //   .filter(mst => this.value.findIndex(item => item.noticeTypeMstUuid === mst.noticeTypeMstUuid) !== -1)
        //   .map(item => item.noticeTypeName).join('、')
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },

    // showDeleteButton () {
    //   return this.model ? true : false
    // }
  },
  watch: {
    value (to) {
      // 1画面に複数のモジュールが設置された場合の識別処理
      if (to && this.buttonId === this.name) {
        // console.log(this.name, to)
        this.changeValue(to)
      }
    },
    model (to) {
      // 初期データを格納
      this.setValue(this.model)
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      loadModel: 'selectNoticeTypeMstModal/loadModel',
      showModal: 'selectNoticeTypeMstModal/show',
      setValue: 'selectNoticeTypeMstModal/setValue'
    }),

    init () {
      // 初期データを格納
      this.setValue(this.model)

      // RSS取得のためデータ読出
      this.loading = true

      //
      let noticeTypeMstParams = {}

      // データ読出し
      this.loadModel({
        noticeTypeMstParams: noticeTypeMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    showSelector () {
      this.showModal({
        buttonId: this.name,
        data: this.value
      })
    },

    changeValue (data) {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        data: data
      })
    },
    // deleteScreen () {
    //   this.$emit('childs-delete', {
    //     name: this.name,
    //     index: this.index
    //   })
    // }
  }
}